<template>
  <b class="score">
    Total score: {{ totalScore }}
    <mark :class="{ boink }">+{{ questionScore }} points</mark>
  </b>
</template>

<script>
export default {
  name: "Score",
  props: {
    questionScore: { type: Number, required: true },
    totalScore: { type: Number, required: true },
  },
  data() {
    return {
      boink: false,
    };
  },
  watch: {
    questionScore(score) {
      if (score) this.boink = true;
    },
  },
};
</script>

<style scoped lang="css">
.score {
  display: block;
  text-align: right;
  position: relative;
}

mark {
  position: absolute;
  bottom: 100%;
  right: 0;
  /* display: block; */
  background: transparent;
  color: #60a931;
  margin-top: 0.6em;
  opacity: 0;
}

mark.boink {
  animation: boink 2s ease-in-out;
}

@keyframes boink {
  0% {
    transform: translateY(5px);
    opacity: 0;
  }

  20% {
    transform: translateY(0);
    opacity: 1;
  }

  80% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-5px);
    opacity: 0;
  }
}
</style>
